export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="11" fill="#0B192C" stroke="rgba(255,255,255,0.18)" />
    <path d="M24 7C24 7 12.5 20.5 12.5 29a11.5 11.5 0 0 0 23 0C35.5 20.5 24 7 24 7z" fill="#FF6B00" />
    <path d="M18 34v-8.5l6 5 6-5V34" fill="none" stroke="#fff" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Set to the uploaded official logo file path, e.g. "/brand/mhm-logo.png".
export const OFFICIAL_LOGO = "/brand/mhm-logo.jpg";

export const BrandLogo = ({ size = "md" }) =>
  OFFICIAL_LOGO ? (
    <img src={OFFICIAL_LOGO} alt="MHM SUPER ADBLUE" className={`${size === "lg" ? "h-40 w-40 md:h-48 md:w-48 rounded-3xl" : "h-12 w-12 rounded-xl"} object-contain shadow-[0_20px_60px_-20px_rgba(0,0,0,0.6)]`} />
  ) : (
    <Logo big={size === "lg"} />
  );

export const Logo = ({ light = true, big = false }) =>
  OFFICIAL_LOGO ? (
    <img src={OFFICIAL_LOGO} alt="MHM SUPER ADBLUE" width="56" height="56" className="h-12 w-12 md:h-14 md:w-14 rounded-xl object-contain ring-1 ring-white/15" />
  ) : (
  <span className="flex items-center gap-3">
    <LogoMark className={big ? "h-16 w-16" : "h-10 w-10"} />
    <span className="leading-none">
      <span className={`block font-display text-xl font-extrabold tracking-wide ${light ? "text-white" : "text-navy"}`}>
        MHM SUPER
      </span>
      <span className="block font-mono text-[11px] font-semibold tracking-[0.35em] text-brand">ADBLUE</span>
    </span>
  </span>
);

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.43 9.43 0 1 1 8 4.42zm8.02-17.45A11.3 11.3 0 0 0 12.05.72C5.8.72.7 5.8.7 12.05c0 2 .52 3.95 1.52 5.66L.6 23.6l6.03-1.58a11.32 11.32 0 0 0 5.42 1.38h.01c6.25 0 11.34-5.08 11.34-11.33 0-3.03-1.18-5.87-3.32-8.01z" />
  </svg>
);
